import React from 'react'
import styles from '../styles.module.css'
import SummaryTable from './Tables/SummaryTable'
import MonitoringTable, { groupMonitoringByOrg } from './Tables/MonitoringTable'


const Table = ({ data }) => {
  if (!data || (!data.summary && !data.monitoring)) return null

  const summaryRows = data.summary?.rows || []
  const eventsByOrg = groupMonitoringByOrg(data.monitoring?.rows)
  const summaryYear = data.summary?.academicYear
  const monitoringYear = data.monitoring?.academicYear

  if (!summaryRows.length) {
    return <div className={styles.noData}>Данные отсутствуют</div>
  }

  return (
    <div className={styles.tableBlock}>
      {summaryRows.map(org => {
        const orgId = org.organizationId
        const events = eventsByOrg[orgId] || []
        return (
          <div key={orgId} className={styles.orgBlock}>
            <SummaryTable row={org} academicYear={summaryYear} />
            {events.length > 0 && (
              <MonitoringTable
                events={events}
                organizationName={org.organizationName}
                academicYear={monitoringYear}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}

export default Table
